import React from 'react';
import { ArrowLeft, PieChart, TrendingUp, Wallet, BarChart2 } from 'lucide-react';

/**
 * PolymarketPage — Página de resultados de la cartera de Polymarket.
 * Placeholder preparado para instalar el módulo de cartera.
 */
const PolymarketPage = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-[#0a0a0b] text-white">
      {/* Header */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0b]/80 backdrop-blur-lg border-b border-gray-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-3">
              <PieChart className="w-5 h-5 text-teal-400" />
              <span className="font-semibold text-sm tracking-wide">Polymarket · Cartera</span>
            </div>
            <button
              onClick={onBack}
              className="flex items-center gap-2 text-gray-400 hover:text-cyan-400 transition-colors text-sm"
              data-testid="polymarket-back-btn"
            >
              <ArrowLeft className="w-4 h-4" />
              Volver
            </button>
          </div>
        </div>
      </nav>

      {/* Content — aquí se instalará el módulo de resultados de cartera */}
      <div className="pt-24 pb-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-bold mb-2">Resultados de Cartera</h1>
            <p className="text-gray-400 text-sm">
              Rendimiento de tus posiciones en mercados de predicción de Polymarket
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Panel principal */}
            <div className="lg:col-span-2 bg-[#0d0d0f] border border-gray-800 rounded-2xl p-10 flex flex-col items-center justify-center text-center min-h-[400px]">
              <div className="w-16 h-16 rounded-2xl bg-teal-500/10 border border-teal-500/30 flex items-center justify-center mb-6">
                <BarChart2 className="w-8 h-8 text-teal-400" />
              </div>
              <h2 className="text-xl font-semibold mb-2">Módulo de cartera</h2>
              <p className="text-gray-400 text-sm max-w-md mb-6">
                Este espacio está reservado para el panel de resultados de la cartera de Polymarket.
                El componente se instalará aquí.
              </p>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-teal-400 animate-pulse" />
                <span className="text-teal-400 text-xs font-medium uppercase tracking-wider">Listo para integración</span>
              </div>
            </div>

            {/* Panel lateral */}
            <div className="space-y-6">
              <div className="bg-[#0d0d0f] border border-gray-800 rounded-2xl p-6">
                <div className="flex items-center gap-2 mb-4">
                  <Wallet className="w-4 h-4 text-teal-400" />
                  <h3 className="text-sm font-semibold">Posiciones</h3>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">
                  Posiciones abiertas, mercados resueltos y exposición actual de la cartera.
                </p>
              </div>
              <div className="bg-[#0d0d0f] border border-gray-800 rounded-2xl p-6">
                <div className="flex items-center gap-2 mb-4">
                  <TrendingUp className="w-4 h-4 text-teal-400" />
                  <h3 className="text-sm font-semibold">Rendimiento</h3>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">
                  P&L histórico, win rate y evolución del valor de la cartera.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolymarketPage;
